// extracted by mini-css-extract-plugin
module.exports = {"container":"_3kV27tvAhzpj1LNK72PZue"};